import React from "react";
import { Link } from "react-router-dom";
import { UserPlus, Landmark, ArrowRight } from "lucide-react";

const Col = ({ id, img, over, title, text, to, btn, Icon, btnCls, bg }) => (
  <div className={`rounded-3xl p-4 md:p-5 flex flex-col sm:flex-row gap-5 ${bg}`} data-testid={`home-cta-${id}`}>
    <img src={img} alt="" className="w-full sm:w-2/5 h-52 sm:h-auto object-cover rounded-2xl"/>
    <div className="flex flex-col py-2 pr-2">
      <span className="overline text-[#C98A3C]">{over}</span>
      <h2 className="font-display text-2xl md:text-3xl font-bold text-aic-navy mt-2 leading-tight">{title}</h2>
      <p className="text-sm text-slate-600 mt-3 leading-relaxed">{text}</p>
      <Link to={to} data-testid={`home-cta-${id}-btn`} className={`${btnCls} text-sm mt-5 self-start`}><Icon className="w-4 h-4"/>{btn}<ArrowRight className="w-4 h-4"/></Link>
    </div>
  </div>
);

export const HomeCta = () => (
  <section className="max-w-7xl mx-auto px-6 py-10 grid lg:grid-cols-2 gap-6" data-testid="home-cta">
    <Col id="artist" img="/cta-artist.jpg" over="Per gli artisti" title="Fai conoscere il tuo talento" bg="bg-[#EEF3FA]"
      text="Crea il tuo profilo gratuito, mostra foto, video e calendario delle date libere e ricevi richieste da Comuni, Pro Loco, Enti e organizzatori di tutta Italia."
      to="/registrati?ruolo=artist" btn="Registrati come artista" Icon={UserPlus} btnCls="btn-pill-navy"/>
    <Col id="pa" img="/cta-pa.jpg" over="Per le Pubbliche Amministrazioni" title="Trova gli artisti giusti per il tuo evento" bg="bg-[#FCF4E6]"
      text="Iscrizione sempre gratuita per gli Enti Pubblici: confronta artisti e fornitori, consulta prezzi e Kit Trasparenza, avvia la trattativa MePA e firma i contratti online."
      to="/login" btn="Accedi come PA" Icon={Landmark} btnCls="btn-pill-gold"/>
  </section>
);
